/*
* @Description: 合作意向管理
* @Author: lqt
* @Date: 2021-05-11 10:46:41
*/
<template>
  <div class="dict-manager" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" :model="cooperationIntentionForm" ref="cooperationIntentionForm" inline
             label-width="70px">
      <el-form-item label="单位名称" prop="company">
        <el-input v-model="cooperationIntentionForm.company"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="name">
        <el-input v-model="cooperationIntentionForm.name"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="cooperationIntentionForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="cooperationIntentionForm.status" placeholder="请选择" value-key="value">
          <el-option
            v-for="item in optionStatusSelect"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发起时间" prop="createTime">
        <el-date-picker
          v-model="cooperationIntentionForm.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜
          索
        </el-button>
        <el-button type="primary" @click="reset">重 置</el-button>
        <!-- <el-button type="primary" @click="goBackTolast">返 回</el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      :data="dictData"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="company"
        label="联融涉及相关方或相关单位        "
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="name"
        label="联系人        "
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系电话        "
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="lrProject"
        label="意向合作项目        "
        :show-overflow-tooltip="true">
       </el-table-column>
      <el-table-column
        prop="createTime"
        label="发起时间        "
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      width="100"
      label="状态"
      :formatter="statusFormatter"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleCheck(scope.$index, scope.row)" v-permission="'0151301'">查看</el-button>
          <el-button v-if="scope.row.status === 0" size="mini" @click="handleVerify(scope.row)" v-permission="'0151302'">受理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <el-button type="primary" @click="handleExport()" v-permission="'0151303'">导出CSV</el-button>
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNum"
      background>
    </el-pagination>
    <check-dialog :show.sync="checkDialogShow" :form-data="checkData"/>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CheckDialog from './checkDialog'

export default {
  name: 'cooperationIntention',
  components: { CheckDialog },
  data () {
    return {
      optionStatusSelect: [
        {
          label: '不限',
          value: ''
        },

        {
          label: '未受理',
          value: 0
        },
        {
          label: '受理',
          value: 1
        }

      ],
      cooperationIntentionForm: {
        id: '',
        name: '',
        phone: '',
        company: '',
        lrProject: '',
        createTime: '',
        status: ''
      },
      statusOptions: [
        {
          label: '未受理',
          value: 0
        },
        {
          label: '受理',
          value: 1
        }
      ],
      checkData: {},
      verifyData: {},
      checkDialogShow: false,
      verifyDialogShow: false
    }
  },
  computed: {
    ...mapState({
      dictData: state => state.cooperationIntention.list,
      listState: state => state.cooperationIntention.listState
    })
  },
  mounted () {
    const params = {
      ...this.cooperationIntentionForm,
      pageNum: 1,
      pageSize: 10
    }
    this.getCooperationIntent(params)
  },
  methods: {
    ...mapActions(['getCooperationIntent', 'exportCooperationIntent', 'cooperationIntentAudit']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    }, // 导出
    // 状态选择框选择某一个
    changeItem (item) {
      this.cooperationIntentionForm.status = item.value
    },
    handleExport () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportCooperationIntent({ ...this.cooperationIntentionForm, pageNo: 1 }).then((res) => {
          function createDownloadFile () {
            let blobObject = new Blob([res])
            let fileName = '合作意向.xls'
            // 兼容 IE系列 浏览器
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobObject, fileName)
            } else {
              let link = document.createElement('a')
              link.download = fileName
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blobObject)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      })
        .catch(() => {
        })
    },
    handleSearch () {
      const params = {
        ...this.cooperationIntentionForm,
        pageNum: 1
      }
      console.log(params)
      console.log('params: ', params)
      this.getCooperationIntent(params)
    },
    reset () {
      this.$refs['cooperationIntentionForm'].resetFields()
      this.handleSearch()
    },
    goBackTolast () {
      this.$router.back(-1)
    },
    handleCheck (index, row) {
      this.checkData = row
      this.checkDialogShow = true
    },
    handleAdd () {
      this.addOrEdit = {}
      this.addOrEdit.dictTypeId = this.$route.query.id
    },
    handleEdit (index, row) {
      this.getCooperationIntent({ })
      let obj = {
        ...row
      }
      this.addOrEdit = obj
      this.addOrEditDialogShow = true
    },
    handleSizeChange (val) {
      this.getCooperationIntent({ pageNum: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getCooperationIntent({ pageNum: val })
    },
    statusFormatter (row) {
      return this.statusOptions.find(item => item.value === row.status).label
    },
    handleVerify (row) {
      this.$confirm('是否确认受理', '受理', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          id: row.id,
          status: 1,
          dr: 0
        }
        this.cooperationIntentAudit(params).then(() => {
          this.$message.success('受理成功')
          this.getCooperationIntent()
        })
      })
    }
  }
}
</script>
